module.exports = __webpack_public_path__ + "static/img/logo.c5ea0be9.svg";